const PAYTRIE_APP_URL = 'https://app.paytrie.com'

export const PAYTRIE_LOGIN_URL = `${PAYTRIE_APP_URL}/LandingLogin`
export const PERSONAL_SIGNUP_URL = `${PAYTRIE_APP_URL}/SignupEmail`
